module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wood@2x_7f1c26.jpg";